import { jsxs as r, jsx as o } from "react/jsx-runtime";

import i from "../../utils/classNames/index.js";

import n from "@ui-components-3/icons/lib/duotone/CircleInfo";

import e from "@ui-components-3/icons/lib/duotone/DiamondExclamation";

import a from "@ui-components-3/icons/lib/duotone/TriangleExclamation";

const t = {
    info: n,
    error: e,
    warning: a
}, s = {
    info: "bg-primary-100",
    error: "bg-fuchsia-100",
    warning: "bg-pantone-200"
}, m = {
    info: "text-primary",
    error: "text-fuchsia-800",
    warning: "text-pantone-800"
}, l = ({children: n, className: e, variant: a = "info", role: l, ...c}) => {
    const p = t[a], d = m[a];
    return void 0 === l && "error" === a && (l = "alert"), r("div", {
        ...c,
        role: l,
        className: i("p-s gap-xs typography-body-l flex items-baseline rounded-2xl text-neutral-800", s[a], e),
        children: [ o("div", {
            className: "h-[1em] shrink-0",
            children: o(p, {
                className: i("h-[21px]", d),
                "aria-hidden": "true"
            })
        }), n ]
    });
};

export { l as default };
//# sourceMappingURL=index.js.map
